// Warning chips from a route's persisted summary counts (no waypoints needed).
// Shared by the planner result step and the expandable route card.
const CHIP_RULES = [
  ["weather", "weather_warnings_count", "error", (n) => `${n} weather`],
  ["rnw", "rnw_warnings_count", "error", (n) => `${n} RNW`],
  ["hra", "hra_warnings_count", "error", (n) => `${n} high risk`],
  ["jwla", "jwla_warnings_count", "error", (n) => `${n} war risk`],
  ["caa", "custom_area_warnings_count", "error", (n) => `${n} operational risk`],
  ["eca", "eca_warnings_count", "warning", (n) => `${n} ECA`],
  [
    "speed",
    "info_speed_limits_count",
    "warning",
    (n) => `${n} speed limit${n !== 1 ? "s" : ""}`,
  ],
]

export default function summaryWarnChips(summary) {
  if (!summary) return []
  const chips = []
  for (const [key, field, severity, label] of CHIP_RULES) {
    const count = Number(summary[field])
    if (Number.isFinite(count) && count > 0) {
      chips.push({ key, severity, label: label(count) })
    }
  }
  return chips
}
